import * as React from 'react';

import { ADULT_MIN_NUMBER } from '@components/views/flight/constants';
import UiGuestSelection from '@uikit/guestSelection';
import ErrorMessage from '@shared/errorMessage';

import { Wrapper } from './styled';

interface IGuests {
  numberOfAdultGuests: number;
  numberOfChildGuests: number;
  numberOfInfantGuests: number;
  onRemoveAdult: () => void;
  onAddAdult: () => void;
  onRemoveChild: () => void;
  onAddChild: () => void;
  onRemoveInfant: () => void;
  onAddInfant: () => void;
  errorMessages: string[];
}

const Guests: React.FC<IGuests> = ({
  numberOfAdultGuests,
  numberOfChildGuests,
  numberOfInfantGuests,
  onRemoveAdult,
  onAddAdult,
  onRemoveChild,
  onAddChild,
  onRemoveInfant,
  onAddInfant,
  errorMessages,
}) => {
  return (
    <Wrapper>
      <UiGuestSelection
        title='Yetişkin'
        label='12+ Yaş'
        counterProps={{
          min: ADULT_MIN_NUMBER,
          disabledDecrement: numberOfAdultGuests === numberOfInfantGuests,
          count: numberOfAdultGuests,
          handleDecrement: onRemoveAdult,
          handleIncrement: onAddAdult,
        }}
      />

      <UiGuestSelection
        title='Çocuk'
        label='2-11 Yaş'
        counterProps={{
          count: numberOfChildGuests,
          handleDecrement: onRemoveChild,
          handleIncrement: onAddChild,
        }}
      />

      <UiGuestSelection
        title='Bebek'
        label='0-2 Yaş'
        counterProps={{
          count: numberOfInfantGuests,
          handleDecrement: onRemoveInfant,
          handleIncrement: onAddInfant,
        }}
      />

      <ErrorMessage errorMessages={errorMessages} />
    </Wrapper>
  );
};

export default Guests;
